import React from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';

// Admin Protected Route - for admin-only pages like competition and leaderboard
const AdminProtectedRoute = ({ children, adminLogin }) => {
  // Check if admin is authenticated
  const isAdminAuthenticated = adminLogin &&
                              adminLogin.data &&
                              adminLogin.data.status === "Success";

  // If not authenticated, redirect to admin login
  if (!isAdminAuthenticated) {
    return <Navigate to="/cyberisland/admin" replace />;
  }

  // If authenticated, render the protected component
  return children;
};

// User Protected Route - for user-only pages like game modules, questions, etc.
const UserProtectedRoute = ({ children, userLogin, urlLogin }) => {
  // Check if user is authenticated - user login returns status "true"
  const isUserAuthenticated = userLogin &&
                             userLogin.data &&
                             (userLogin.data.status === "true" || userLogin.data.gameUserid);

  // Check if the user came in through the URL login flow (gameUserId/accountUserId/callbackUrl)
  const isUrlAuthenticated = urlLogin &&
                             urlLogin.urlLoginResponse &&
                             urlLogin.urlLoginResponse.userName;

  // On refresh the redux state is lost, but the params stay in the URL path, so
  // treat the presence of the url params as an authenticated url-login session
  const hasUrlParams = window.location.href.indexOf("gameUserId=") !== -1;

  // If not authenticated, redirect to user login
  if (!isUserAuthenticated && !isUrlAuthenticated && !hasUrlParams) {
    return <Navigate to="/cyberisland/login" replace />;
  }

  // If authenticated, render the protected component
  return children;
};

const mapStateToPropsAdmin = (state) => {
  return {
    adminLogin: state.GameReducer.adminLogin,
  };
};

const mapStateToPropsUser = (state) => {
  return {
    userLogin: state.GameReducer.login,
    urlLogin: state.GameReducer.urlloginresponse,
  };
};

const AdminProtected = connect(mapStateToPropsAdmin)(AdminProtectedRoute);
const UserProtected = connect(mapStateToPropsUser)(UserProtectedRoute);

export { AdminProtected, UserProtected };

// Keep the original for backward compatibility
const ProtectedRoute = AdminProtectedRoute;
export default connect(mapStateToPropsAdmin)(ProtectedRoute);